var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_11715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.31949 13.5803C5.27151 14.1946 2.52378 15.4488 4.19733 17.0183C5.01485 17.785 5.92535 18.3333 7.07007 18.3333H13.6021C14.7469 18.3333 15.6574 17.785 16.4749 17.0183C18.1484 15.4488 15.4007 14.1946 14.3527 13.5803C11.8952 12.1399 8.77702 12.1399 6.31949 13.5803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31949 13.5803C5.27151 14.1946 2.52378 15.4488 4.19733 17.0183C5.01485 17.785 5.92535 18.3333 7.07007 18.3333H13.6021C14.7468 18.3333 15.6574 17.785 16.4749 17.0183C18.1484 15.4488 15.4007 14.1946 14.3527 13.5803C11.8952 12.1399 8.77702 12.1399 6.31949 13.5803Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6691 6.66659C13.6691 8.50753 12.1767 9.99992 10.3358 9.99992C8.49482 9.99992 7.00244 8.50753 7.00244 6.66659C7.00244 4.82564 8.49482 3.33325 10.3358 3.33325C12.1767 3.33325 13.6691 4.82564 13.6691 6.66659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6691 6.66659C13.6691 8.50754 12.1767 9.99992 10.3358 9.99992C8.49482 9.99992 7.00244 8.50754 7.00244 6.66659C7.00244 4.82564 8.49482 3.33325 10.3358 3.33325C12.1767 3.33325 13.6691 4.82564 13.6691 6.66659Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3824 7.91663L19.0053 7.32953C19.3369 7.01704 19.5028 6.86079 19.5028 6.66663C19.5028 6.47247 19.3369 6.31621 19.0053 6.00371L18.3824 5.41663M19.4856 6.66663H16.1694",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_11715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.335938 0.833252)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRightArrow);
export default __webpack_public_path__ + "static/media/user-right-arrow.8f378b27eac2c216b087071bc804b54c.svg";
export { ForwardRef as ReactComponent };